import { red } from '@mui/material/colors';
import { frFR } from '@mui/material/locale';
import { createTheme } from '@mui/material/styles';

// A custom theme for this app
const theme = createTheme(
  {
    palette: {
      primary: {
        main: '#678034',
      },
      secondary: {
        main: '#CE0030',
      },
      error: {
        main: red.A400,
      },
    },
  },
  frFR,
);

export default theme;
